module.exports = __webpack_public_path__ + "static/media/rectangle-tooltip.c404dc64.svg";